<template>
    <div>
        <div class="content-header text-center">
            <h2>Check Status (sessions sandbox)</h2>
            <p>Test functions that switch a user status from inactive to active.</p>
        </div>
        <div class="container-fluid min-content-height">
            <div class="row">
                <div class="col">
                    <button class="btn btn-lg btn-primary" @click="$emit('activateUser',{status: 'active'})">Set Active Status</button>
                    <button class="btn btn-lg btn-primary" @click="$emit('deactivateUser',{status: 'inactive'})">Set Inactive Status</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
  name: 'sessionCheck',
  data () {
    return {
      status: this.userStatus
    }
  },
  mounted () {
    axios({
      method : 'POST',
      url : '/check_session_status',
      data:'',
    }).then(
            (response) => {
			    this.status = response.data;
          
                console.log('test initial status: ' + response.data)
            })
        .catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
        });
  },
  methods: {
    
  }
}
</script>
